import OrderStatus from "../types/models/OrderStatus";

// env constants
export const API_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

// utils constants
export const LOCAL_TOKEN = "access_token";
export const LOCAL_USER = "user";

// url constants (endpoints)
export const API_AUTH_URL = API_URL + "auth";
export const API_AUTH_LOGIN_URL = API_AUTH_URL + "/login";
export const API_ORDERS_URL = API_URL + "orders";
export const API_ORDERS_BY_INVOICE_URL = API_ORDERS_URL + "/invoice";
export const API_ORDERS_REQUESTS_URL = API_ORDERS_URL + "/requests";
export const API_ORDERS_ORDERS_URL = API_ORDERS_URL + "/orders";
export const API_ORDERS_REMINDERS_URL = API_ORDERS_URL + "/reminders";
export const API_ADVISORS_URL = API_URL + "advisors";
export const API_PRODUCTS_URL = API_URL + "products";
export const API_INSTALLERS_URL = API_URL + "installers";
export const API_PROSPECTS_URL = API_URL + "prospects";
export const API_PROSPECTS_APPOINTMENTS_URL = API_URL + "prospects-appointments";
export const API_USERS_URL = API_URL + "users";
export const API_CLIENTS_URL = API_URL + "clients";
export const API_GUARANTEES_URL = API_URL + "guarantees";
export const API_GUARANTEES_HISTORY_URL = API_GUARANTEES_URL + "/history";
export const API_ZIPCODES_URL = API_URL + "zipcodes";
export const API_ORDER_REPORTS_URL = API_URL + "reports/orders";

// utils
export const ORDER_STATUS_VALIDANDO_PEDIDO = "IN_VALIDATION";
export const ORDER_STATUS_EN_PRODUCCION = "IN_PRODUCTION";
export const ORDER_STATUS_RECIBIDO_EN_ALMACEN = "RECEIVED_IN_WAREHOUSE";
export const ORDER_STATUS_LISTO_PARA_AGENDAR = "READY_TO_SCHEDULE";
export const ORDER_STATUS_AGENDADO = "SCHEDULED";
export const ORDER_STATUS_PROYECTO_TERMINADO = "COMPLETED";
export const ORDER_STATUS_PROYECTO_INCONCLUSO = "INCOMPLETE";
export const ORDER_STATUS_CANCELADO = "CANCELED";

export const TRACING_STATUSES: OrderStatus = {
	1: {
		name: "Seguimiento #1",
		color: "green"
	},
	2: {
		name: "Seguimiento #2",
		color: "olive"
	},
	3: {
		name: "Seguimiento #3",
		color: "yellow"
	},
	4: {
		name: "Seguimiento #4",
		color: "orange"
	},
	5: {
		name: "Seguimiento #5",
		color: "red"
	},
};

export const ORDERS_STATUSES: OrderStatus = {
	DRAFT: {
		name: "Borrador",
		color: "teal"
	},
	IN_VALIDATION: {
		name: "Validando pedido",
		color: "yellow"
	},
	IN_PRODUCTION: {
		name: "En produccion",
		color: "grey"
	},
	RECEIVED_IN_WAREHOUSE: {
		name: "Recibido en almacen",
		color: "olive"
	},
	READY_TO_SCHEDULE: {
		name: "Listo para agendar",
		color: "green"
	},
	SCHEDULED: {
		name: "Agendado",
		color: "orange"
	},
	COMPLETED: {
		name: "Proyecto terminado",
		color: "blue"
	},
	INCOMPLETE: {
		name: "Proyecto inconcluso",
		color: "brown"
	},
	CANCELED: {
		name: "Cancelado",
		color: "red"
	},
};

export const PROSPECTS_STATUSES: OrderStatus = {
	SCHEDULED: {
		name: "Agendado",
		color: "yellow"
	},
	VISITED: {
		name: "Visitado",
		color: "blue"
	},
	ASSIGNED: {
		name: "Asignado",
		color: "yellow"
	},
	IN_TRACING: {
		name: "En seguimiento",
		color: "blue"
	},
	SALE_CONCRETED: {
		name: "Venta concretada",
		color: "green"
	},
	SALE_NOT_CONCRETED: {
		name: "Venta no concretada",
		color: "red"
	},
	SALE_COMPLETED: {
		name: "Venta concretada",
		color: "green"
	},
	SALE_NOT_COMPLETED: {
		name: "Venta no concretada",
		color: "red"
	},
	CANCELED: {
		name: "Cita cancelada",
		color: "red"
	},
	COMPLETED: {
		name: "Completado",
		color: "black"
	},
};

export const PROSPECT_ORIGIN_LABELS: Record<string, string> = {
	FACEBOOK: "Facebook",
	INSTAGRAM: "Instagram",
	WHATSAPP: "WhatsApp",
	WEB_PAGE: "Página web",
	PHONE_CALL: "Llamada",
	EMAIL: "Correo electrónico",
	EXISTING_CUSTOMER: "Cliente existente",
};

export const ROLE_PERFORMANCE_EVENT_LABELS: Record<string, string> = {
	EXTERNAL_UPDATE: "Actualización externa",
};

export const ROLE_PERFORMANCE_DETAIL_LABELS: Record<string, string> = {
	CON_GARANTIA: "Con garantía",
	SIN_GARANTIA: "Sin garantía",
};

export const GUARANTEE_TYPE_ADJUSTMENT = "ADJUSTMENT";
export const GUARANTEE_TYPE_GUARANTEE = "GUARANTEE";
export const GUARANTEE_TYPE_UNFINISHED = "UNFINISHED";

export const GUARANTEE_TYPE_LABELS: Record<string, string> = {
	[GUARANTEE_TYPE_ADJUSTMENT]: "Ajuste",
	[GUARANTEE_TYPE_GUARANTEE]: "Garantía",
	[GUARANTEE_TYPE_UNFINISHED]: "Proyecto inconcluso",
};

export const GUARANTEE_STATUS_OPEN = "OPEN";
export const GUARANTEE_STATUS_COMPLETED = "COMPLETED";

export const GUARANTEE_STATUS_LABELS: Record<string, string> = {
	[GUARANTEE_STATUS_OPEN]: "Abierta",
	[GUARANTEE_STATUS_COMPLETED]: "Terminada",
};

// datatables
export const DT_CUSTOM_STYLES = {
	head: {
		style: {
			fontSize: "14px",
			fontWeight: 800,
		},
	},
};

export const DT_PAGINATION_COMPONENT_OPTIONS = {
	rowsPerPageText: "Filas por página",
	rangeSeparatorText: "de",
	selectAllRowsItem: true,
	selectAllRowsItemText: "Todos",
};

// user roles
export const USER_ROLE_ADMINISTRATOR = "ADMINISTRATOR";
export const USER_ROLE_LOGISTIC = "LOGISTIC";
export const USER_ROLE_ORDERS = "ORDERS";
export const USER_ROLE_SOCIAL_MEDIA = "SOCIAL_MEDIA";
export const USER_ROLE_ADVISOR = "ADVISOR";
export const USER_ROLE_INSTALLER = "INSTALLER";

// user role labels
export const USER_ROLES = {
	ADMIN: {
		key: USER_ROLE_ADMINISTRATOR,
		label: "Administrador",
	},
	LOGISTIC: {
		key: USER_ROLE_LOGISTIC,
		label: "Logistica",
	},
	ORDERS: {
		key: USER_ROLE_ORDERS,
		label: "Pedidos",
	},
	SOCIAL_MEDIA: {
		key: USER_ROLE_SOCIAL_MEDIA,
		label: "Redes sociales",
	},
	ADVISOR: {
		key: USER_ROLE_ADVISOR,
		label: "Asesor",
	},
	INSTALLER: {
		key: USER_ROLE_INSTALLER,
		label: "Instalador",
	},
};
